<nav>
  <ul class="flex items-center w-fit">
    <li
      class="px-3 pb-3 border-b-2 cursor-pointer"
      [class.active]="(activeSection$ | async) === 'name'"
      (click)="onNavItemClick('name')"
    >
      {{ 'update-settings.nav.name' | translate }}
    </li>
    <div class="w-6 h-[38px] border-b-2 border-[#F9F9F9]"></div>
    <li
      class="px-3 pb-3 border-b-2 cursor-pointer"
      [class.active]="(activeSection$ | async) === 'logos'"
      (click)="onNavItemClick('logos')"
    >
      {{ 'update-settings.nav.logos' | translate }}
    </li>
    <div class="w-6 h-[38px] border-b-2 border-[#F9F9F9]"></div>
    <li
      class="px-3 pr-3 pb-3 border-b-2 cursor-pointer"
      [class.active]="(activeSection$ | async) === 'monetization'"
      (click)="onNavItemClick('monetization')"
    >
      {{ 'update-settings.nav.monetization' | translate }}
    </li>
    <div class="w-6 h-[38px] border-b-2 border-[#F9F9F9]"></div>
    <li
      class="px-3 pr-3 pb-3 border-b-2 cursor-pointer"
      [class.active]="(activeSection$ | async) === 'privacy'"
      (click)="onNavItemClick('privacy')"
    >
      {{ 'update-settings.nav.privacy' | translate }}
    </li>
  </ul>
</nav>
